const {
  REACT_APP_ENV,
  REACT_APP_PROD_API_URL,
  REACT_APP_DEV_API_URL,
  REACT_APP_AUTH0_DOMAIN_PROD,
  REACT_APP_AUTH0_CLIENT_ID_PROD,
  REACT_APP_AUTH0_DOMAIN_DEV,
  REACT_APP_AUTH0_CLIENT_ID_DEV,
} = process.env;

export const IS_PROD = REACT_APP_ENV === 'production';
export const API_URL = IS_PROD ? REACT_APP_PROD_API_URL : REACT_APP_DEV_API_URL;
console.log('API_URL:', API_URL);
console.log('REACT_APP_ENV:', REACT_APP_ENV);

export const AUTH0_DOMAIN = IS_PROD
  ? REACT_APP_AUTH0_DOMAIN_PROD
  : REACT_APP_AUTH0_DOMAIN_DEV;
console.log('AUTH0_DOMAIN:', AUTH0_DOMAIN);

export const AUTH0_CLIENT_ID = IS_PROD
  ? REACT_APP_AUTH0_CLIENT_ID_PROD
  : REACT_APP_AUTH0_CLIENT_ID_DEV;

export const LEFT_COL_WIDTH = '294px';

export const CONFIG = {
  TABLE_PAGE_SIZE: 10,
};

// 1 minute
export const TRANSPORT_POSITION_POLLING_INTERVAL = 60000;
export const ALL_ROUTES_POSITION_POLLING_INTERVAL = 60000;
